module.exports = __webpack_public_path__ + "img/2.6e4498bf.png";